import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import './EditProfile.css';

export default function EditProfile() {
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    company: '',
    linkedIn: '',
    resume: null
  });

  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!token) {
      setMessage("You must be logged in to edit your profile.");
      return;
    }

    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/business-card`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!response.ok) throw new Error("Failed to fetch business card");

        const data = await response.json();
        setFormData({
          name: data.name || '',
          title: data.title || '',
          company: data.company || '',
          linkedIn: data.linkedIn || '',
          resume: null
        });
      } catch (err) {
        console.error(err);
        setMessage("Could not load profile info.");
      }
    };

    fetchData();
  }, [token, API_BASE_URL]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;

    setLoading(true);
    setMessage('');

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("title", formData.title);
      form.append("company", formData.company);
      form.append("linkedIn", formData.linkedIn);
      if (formData.resume) form.append("resume", formData.resume);

      const response = await fetch(`${API_BASE_URL}/businesscard/update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: form
      });

      if (!response.ok) throw new Error("Update failed");

      setMessage("Profile updated successfully!");
      navigate("/Profile");
    } catch (err) {
      console.error(err);
      setMessage("Failed to update profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-profile-page">
      <h2>Edit Your Profile</h2>
      {message && <p className="edit-profile-message">{message}</p>}

      <form className="edit-profile-form" onSubmit={handleSubmit}>
        <label>Name:</label>
        <input name="name" value={formData.name} onChange={handleChange} required />

        <label>Title:</label>
        <input name="title" value={formData.title} onChange={handleChange} required />

        <label>Company:</label>
        <input name="company" value={formData.company} onChange={handleChange} required />

        <label>LinkedIn URL:</label>
        <input name="linkedIn" value={formData.linkedIn} onChange={handleChange} />

        <label>Resume File:</label>
        <input type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleChange} />
        {formData.resume && <small>Selected file: {formData.resume.name}</small>}

        <button type="submit" disabled={loading}>
          {loading ? "Updating..." : "Save Changes"}
        </button>
      </form>
    </div>
  );
}
